// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"5dabaacb","484":"ec09f80b","548":"b09602af","551":"cfcc5244","629":"d0483110","828":"7ae44d4d","842":"c129acde","950":"7c7e56bc"}[chunkId] + ".chunk.js";
};